export default __webpack_public_path__ + "static/media/profile4.72943b8c.jpg";